export const extractUserSessionTokens = sessionInfo => {
  const {
    accessToken: {
      jwtToken: accessToken,
      payload: {
        exp: expire,
        sub: uid
      }
    },
    idToken: {
      jwtToken: idToken,
    },
    refreshToken: {
      token: refreshToken,
    }
  } = sessionInfo;

  return {
    uid,
    accessToken,
    idToken,
    refreshToken,
    expire
  }
};
